import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import NotFound from '@/pages/not-found';
import { Route, Switch, Router as WouterRouter } from 'wouter';
import { Home } from './pages/Home';
import { RoomPage } from './pages/RoomPage';
import { ContactsPage } from './pages/ContactsPage';

const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/room/:roomId" component={RoomPage} />
      <Route path="/contacts" component={ContactsPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  useEffect(() => {
    // ROOM ne doit pas conserver de cache frontend
    // ni utiliser un ancien Service Worker.
    if ('serviceWorker' in navigator) {
      void navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          for (const registration of registrations) {
            void registration.unregister();
          }
        })
        .catch(() => {
          // Service Worker indisponible : rien à faire.
        });
    }

    // Supprime les anciens caches éventuellement laissés
    // par les versions précédentes de ROOM.
    if ('caches' in window) {
      void caches
        .keys()
        .then((keys) => {
          return Promise.all(
            keys.map((key) => caches.delete(key)),
          );
        })
        .catch(() => {
          // Cache Storage indisponible : rien à faire.
        });
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <WouterRouter
          base={import.meta.env.BASE_URL.replace(/\/$/, '')}
        >
          <Router />
        </WouterRouter>

        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
